import { Component } from 'react'
import * as Sentry from '@sentry/react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMessage: '', componentStack: '' }
  }

  static getDerivedStateFromError(error) {
    let msg = 'Unbekannter Fehler'
    try { msg = error?.message || String(error) } catch { /* ignore */ }
    return { hasError: true, errorMessage: msg }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
    let stack = ''
    try { stack = errorInfo?.componentStack || '' } catch { /* ignore */ }
    this.setState({ componentStack: stack })
    if (import.meta.env.DEV) {
      try {
        const msg = String(error?.message || error).slice(0, 200)
        alert('Debug-Fehler:\n' + msg + '\n\nComponent Stack (erste 300Z):\n' + stack.slice(0, 300))
      } catch { /* ignore */ }
    }
    try {
      Sentry.withScope((scope) => {
        scope.setExtra('componentStack', stack)
        Sentry.captureException(error)
      })
    } catch { /* ignore */ }
    try {
      window.umami?.track('error-boundary-triggered', { errorType: String(error?.name || 'UnknownError').slice(0, 50) })
    } catch { /* ignore */ }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <span className="material-symbols-outlined error-boundary__icon">error</span>
          <h1 className="error-boundary__title">Etwas ist schiefgelaufen</h1>
          <p className="error-boundary__msg">
            Ein unerwarteter Fehler ist aufgetreten. Bitte laden Sie die Seite neu.
          </p>
          <details style={{ marginTop: 12, maxWidth: 320, textAlign: 'left' }}>
            <summary style={{ fontSize: '0.75rem', color: '#666', cursor: 'pointer' }}>Details</summary>
            <pre style={{ fontSize: '0.65rem', color: '#333', background: '#f5f5f5', padding: 8, borderRadius: 4, marginTop: 4, whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: 200, overflow: 'auto' }}>
              {this.state.errorMessage}{this.state.componentStack ? '\n\n' + this.state.componentStack : ''}
            </pre>
          </details>
          <button className="error-boundary__btn" onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
